import { createFileRoute, Outlet } from '@tanstack/react-router';
import { createOrgManagerGuard } from '../../lib/auth/permissionGuards';

export const Route = createFileRoute('/$slug/organization')({
  component: Outlet,
  beforeLoad: createOrgManagerGuard()
});
